import React from 'react';
import { useMediaQuery } from '@react-hook/media-query';

const ContactForm = ({
  handleSubmit,
  contactUsLoading,
  onSubmit,
  register,
  errors,
  queryType,
  setQueryType
}: {
  handleSubmit: any;
  contactUsLoading: boolean;
  onSubmit: (data: any) => void;
  register: any;
  errors: any;
  queryType: string;
  setQueryType: React.Dispatch<React.SetStateAction<string>>;
}) => {

   const isMobile = useMediaQuery('(max-width: 767px)');

  return (
    <div
      className="modal custom-modal fade check-availability-modal"
      id="enquiry"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content py-0">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 d-flex justify-content-end"></div>
                <div className="col-md-4 text-center">
                  <h4 className="mb-0  fw-bold text-uppercase py-3">
                    Get in touch!
                  </h4>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  <span
                    // className="align-center text-black d-none d-md-flex fs-xx-large"
                    className="align-center text-black fs-xx-large" 
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    aria-hidden="true"
                    style={{ cursor: 'pointer',
                       ...(isMobile ? { position: 'absolute', top: '10px', right: '0px' } : {}), 
                     }}
                    onClick={() => {
                      const backdrop = document.querySelector('.modal-backdrop');
                      const locationModal =
                        document.getElementById('enquiry');

                      if (locationModal) {
                        locationModal.style.display = 'none';
                        locationModal.classList.remove('show', 'modal-open');
                      }
                      if (backdrop) {
                        backdrop.remove();
                      }

                      document.body.classList.remove('modal-open');
                      document.body.style.overflow = '';
                      document.body.style.paddingRight = '';
                       setQueryType('enquiry');
                    }}
                  >
                    ×
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-center my-3">
                  <img src="/assets/img/enquiry.png" alt="Img" />
                </div>
                {queryType === 'location_availability' && (
                  <div className="col-md-12 text-center my-3">
                    <p>Please fill in this form and we will get back to you asap</p>
                  </div>
                )}
              </div>

              <div className="row justify-content-center">

                <div className="col-md-8 ">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="text"
                          className={`form-control mb-0 py-2 ${errors.name ? 'is-invalid' : ''}`}
                          placeholder="Name *"
                          {...register('name')}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="text"
                          className={`form-control mb-0 py-2 ${errors.email ? 'is-invalid' : ''}`}
                          placeholder="Email *"
                          {...register('email')}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="number"
                          className={`form-control mb-0 py-2 ${errors.phone ? 'is-invalid' : ''}`}
                          placeholder="Mobile"
                          {...register('phone')}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <textarea
                          className={`form-control mb-0 py-2 ${errors.message ? 'is-invalid' : ''}`}
                          rows={4}
                          cols={50}
                          placeholder="Message *"
                          defaultValue={'\t\t\t\t\t\t\t\t\t\t\t'}
                          {...register('message')}
                        />
                      </div>
                    </div>

                    {/* <div className="col-md-12">
                      <label className="flex items-start gap-2">
                        <input
                          type="checkbox" 
                          {...register('is_sms_alert_approved')}
                          className={`me-2 ${errors.is_sms_alert_approved ? 'is-invalid' : ''}`}
                        />
                        <small className="text-sm text-gray-600">
                          <span>
                            Yes, I’d like to receive SMS alerts from Fairental
                            for booking confirmations, payment updates, support
                            messages, and important reminders.
                          </span>
                        </small>
                      </label>

                      <small className="text-sm text-gray-600">
                        <i>
                          {' '}
                          Message and data rates may apply. Reply STOP to
                          unsubscribe.{' '}
                        </i>
                      </small>
                    </div> */}

                    <div className="col-md-12 mt-1 mb-2">
                      <div className="input-block m-0">
                        <label
                          className="custom_check d-inline-flex location-check m-0"
                        >
                          <span>
                            <small className="text-sm  ">
                              <p>
                                Yes, I’d like to receive SMS alerts from
                                Fairental for booking confirmations, payment
                                updates, support messages, and important
                                reminders.
                              </p>
                            </small>
                            <small className="text-sm  ">
                              <i>
                                <p> Message and data rates may apply. Reply STOP to
                                  unsubscribe.{' '}
                                </p>
                              </i>
                            </small>
                          </span>

                          <input
                            type="checkbox"
                            className={`form-control mb-0 ${errors.is_sms_alert_approved ? 'is-invalid' : ''}`}
                            {...register('is_sms_alert_approved')}
                          />
                          <span
                            style={{ padding: 5 }}
                            className={`checkmark form-control ${errors.is_sms_alert_approved ? 'is-invalid' : ''}`}
                          />
                        </label>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-1"
                        disabled={contactUsLoading}
                      >
                        {' '}
                        {contactUsLoading ? 'Sending..' : 'Submit Enquiry'}
                      </button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
